import { formatDate, formatDateUTC, IDeaRegistration, mailTo, useUserContext } from '../common';
import { replace as lreplace } from 'lodash/fp';

export const show = (value: keyof IDeaRegistration) => (a: IDeaRegistration) =>
  value === 'busAddress'
    ? mailTo(getUserAddress())
    : value === 'orgAddress'
    ? mailTo(a['busAddress'])
    : value === 'expDt' || value === 'appStatusDt' || value === 'provisionDt'
    ? formatDateUTC(a[value])
    : value === 'regStatus'
    ? lreplace(/_/g, ' ')(a[value]) 
    : value === 'certStatus'
    ? lreplace(/_/g, ' ')(a[value])
    : a[value];

const getUserAddress = () => {
  const { user } = useUserContext();
  return user.address ?? '';
}
